export const getCheck24Namespace = () => {
    if (window.c24?.travelapi) {
        return window.c24.travelapi;
    } else if (window._ns) {
        return window._ns;
    }
    throw new Error(
        'FATAL: window._ns and window.c24.travelapi is not available!'
    );
};

export const getCheck24NamespaceRoot = () => {
    if (window.c24) {
        return window.c24;
    } else if (window._ns) {
        return window._ns;
    }
    throw new Error('FATAL: window._ns and window.c24 is not available!');
};

export function getC24App() {
    if (window.C24App) {
        return window.C24App;
    }
    throw new Error('FATAL: window.C24App is not available!');
}
export function getCheck24Wireframe() {
    return window.Check24;
}
